import classNames from "classnames";
import style from "./Button.module.scss";

export const Button = ({ children, className, ...rest }) => (
  <button type="button" className={classNames(style.root, className)} {...rest}>
    {children}
  </button>
);
